import React, { ReactNode } from "react";
import { ListBullet } from "@UI/Components/List/List";
import { Flex } from "@UI/Components/Flex/Flex";
import { Bold } from "@UI/Components/Bold/Bold";
import { Text } from "@UI/Components/Text/Text";

interface SubItemProps {
  title: string | ReactNode;
  children?: ReactNode;
  price?: ReactNode | number;
  nested?: boolean;
}
export const SubItem = ({
  title,
  children,
  price,
  nested = false,
}: SubItemProps) => {
  return (
    <>
      <Flex justifyContent="space-between" flexGrow="1" ml={nested ? 4 : 0}>
        <Flex flexDirection="column">
          <Flex>
            <ListBullet />
            <Text m={0}>{title}</Text>
          </Flex>
        </Flex>

        {price && ( // we allow items to not have a price (e.g. for titles)
          <Flex>
            <Bold>{price}</Bold>
          </Flex>
        )}
      </Flex>
      {children}
    </>
  );
};
